export enum ColorOption {
  WHITE = 'white',
  CHARCOAL = 'charcoal',
  BLACK = 'black',
  DARK_BROWN = 'dark_brown',
  DARK_GREY = 'dark_grey',
  GOLD = 'gold',
  RED = 'red',
  TEAL = 'teal',
  PURPLE = 'purple',
}
